<template>
    <div class="reveal-accordions">
        <SlideInTransition v-show="$parent.content0Visible" from="left">
            <div class="side p-x">
                <h2>
                    Empfehlungen zu täglichen Mediennutzungszeiten
                </h2>
            </div>
        </SlideInTransition>
        <div class="side half p-x">
            <transition
                name="fade"
                appear
            >
                <div v-if="$parent.content1Visible" class="outer-image-wrapper">
                    <div class="image-wrapper">
                        <img
                            :src="image"
                            class="block full-width"
                        >
                        <div class="title x-large-size">
                            <slot />
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <div class="side half p-r">
            <ContentCard
                v-for="index in visibleCards"
                :key="index"
                :expanded="cards[index].expanded"
                :center-header="cards[index].centerHeader"
                :pulsating="cards[index].pulsating"
                :class="[`card-${index}`, clickable && 'clickable']"
                :width="45"
                @click.once.native="expandCard(index)"
            >
                <template #header>
                    <span v-html="cards[index].header" />
                </template>
                <p v-html="cards[index].content" />
            </ContentCard>
        </div>
    </div>
</template>

<script>
import gsap from 'gsap';
import SlideState from '@/mixins/SlideState';

export default {
    mixins: [SlideState],
    props: {
        cardsData: {
            type: Array,
            required: true
        },
        image: {
            type: String,
            required: true
        }
    },
    data()
    {
        return {
            cards: this.cardsData.map(data => ({
                header: data.header,
                content: data.content,
                expanded: false,
                centerHeader: false,
                pulsating: false
            })),
            visibleCards: [],
            clickable: false
        };
    },
    watch: {
        '$parent.content2Visible': function(val)
        {
            if (val && !this.hasState()) { return; }
            this.cards.forEach((card, index) =>
            {
                this.showCard(index);
                card.expanded = true;
                card.centerHeader = false;
            });
            this.$nextTick(() => this.finish(0.8));
        }
    },
    mounted()
    {
        if (this.hasState()) { return; }
        this._tween = gsap.timeline()
            .add(() => this.showCard(0), 1.5)
            .add(() => this.showCard(1), 2.5)
            .add(() => this.showCard(2), 3.5)
            .add(() => this.pulseCard(0), 4)
            .add(() => this.pulseCard(1), 4.5)
            .add(() => this.pulseCard(2), 5)
            .add(() => { this.clickable = true; });
    },
    destroyed()
    {
        if (this._tween)
        {
            this._tween.kill();
        }
    },
    methods: {
        expandCard(index)
        {
            this.cards[index].pulsating = false;
            this.cards[index].expanded = true;
            this.cards[index].centerHeader = false;

            if (this.cards.every(card => card.expanded))
            {
                this._tween = gsap.delayedCall(2, this.finish);
                this.saveState(true);
            }
        },
        showCard(index)
        {
            this.visibleCards.push(index);
        },
        pulseCard(index)
        {
            this.cards[index].pulsating = true;
        },
        finish()
        {
            this.$parent.setNextButtonActive();
        }
    }
};
</script>

<style lang="scss" src="./RevealAccordions.scss" />
